module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f99d.09b38a6d.svg";